const releases = [
    {
        "id": "NEx1",
        "name": "... by Leo",
        "artist": "Leo from Vermont",
        "date": "2016",
        "description": "Waxidermy mix swap 2016",
        "image": "https://nighterrands.s3.amazonaws.com/ByLeo/byleo.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/ByLeo/byleo-small.jpg",
        "section": "collage",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/ByLeo/01+Track+01.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/02+Track+02.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/03+Track+03.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/04+Track+04.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/05+Track+05.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/06+Track+06.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/07+Track+07.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/08+Track+08.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/09+Track+09.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/10+Track+10.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/11+Track+11.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/12+Track+12.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/13+Track+13.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/14+Track+14.mp3",
            "https://nighterrands.s3.amazonaws.com/ByLeo/15+Track+15.mp3"
        ]
    },
    {
        "id": "NEx2",
        "name": "... meets the Sea Men",
        "artist": "Leo from Vermont",
        "date": "December 11, 2016",
        "description": "Suddenly our hero awakens \nadrift at sea \nin the belly of \na creature for whom he has no name. \n\nHe is utterly alone and, while in the beast, he is neither safe nor in great danger. He decides that whatever the cost, he will be free. Libertatem, sive mors. Or maybe he'll just see what, in the name of science and industry, this wee beastie has to offer in the way of fun. \n\nTurns out this is only slightly better than licking toads. \n\nHe is able to record his thoughts on his iphone, which, rescued from the primordial soup, proves sufficient. \n\nAnd shut up about the hiss. I know about the stupid tape hiss. My 1997 space portal CD burner died, give a fella a break. The break broke the bastard, as it were. One tune deep. \n\nSo fuck off already. \n\nLove and snuggles, \nDr. Love Doctor, esq.\ncredits\n\nLeo: Yay \nMike: Nay \nTY: Stuck in the driveway\n",
        "image": "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/meets_the_sea_man.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/meets_the_sea_man-small.jpg",
        "section": "album",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/01-comp.mp3",
            "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/02-comp.mp3",
            "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/03-comp.mp3",
            "https://nighterrands.s3.amazonaws.com/...+meets+the+Sea+Man/04-comp.mp3"
        ]
    },
    {
        "id": "NEx3",
        "name": "Leo's Pick: The Champ Label",
        "artist": "Leo from Vermont",
        "date": "2009",
        "description": "Waxidermy mix swap 2009",
        "image": "https://nighterrands.s3.amazonaws.com/Champ+Mix/champ.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Champ+Mix/champ.jpg",
        "section": "mix",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/01+Never+grow+old.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/02+Don't+say+nothing.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/03+Get+ready.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/04+Going+home.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/05+I'm+going+away.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/06+Friend.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/07+After+a+while.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/08+Keep+on+serving+god.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/09+Walk+through+the+valley.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/10+If+I+had+a+hammer.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/11+Didn't+he+mama.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/12+Changes.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/13+Do+you+believe.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/14+Holy+ghost+trip.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/15+Best+thing+that+ever+happened+to+me.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/16+Serve+him+right.mp3",
            "https://nighterrands.s3.amazonaws.com/Champ+Mix/17+Farther+along.mp3"
        ]
    },
    {
        "id": "NEx4",
        "name": "Amity, Island of",
        "artist": "Leo from Vermont",
        "date": "2017",
        "description": "Waxidermy mix swap 2017",
        "image": "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/amity.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/amity.jpg",
        "section": "collage",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/01+Welcome+to.mp3",
            "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/02+Stay+Funky.mp3",
            "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/03+Twilights+First+Spirits.mp3",
            "https://nighterrands.s3.amazonaws.com/Amity+Island+Of+Album/04+The+long+walk+home+from+the+flying+horses.mp3"
        ]
    },
    {
        "id": "NEx5",
        "name": "The Coldest Days",
        "artist": "Leo from Vermont",
        "date": "2009",
        "description": "Waxidermy mix swap 2009",
        "image": "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/coldestdays.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/coldestdays.jpg",
        "section": "mix",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/01+My+Life+story.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/02+Judgment+Morning.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/03+Changes.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/04+Worship+him.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/05+Lord%2C+it's+you+for+me.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/06+Surrender+soon.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/07+So+close.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/10+Let+Jesus+be+in+your+life.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/11+Satisfaction+Guarenteed.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/12+Brothers+%26+Sisters.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/13+revelation.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/14+Trust+in+Jesus.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/15+I+know+jesus+is+the+answer+2.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/15+I+know+jesus+is+the+answer.mp3",
            "https://nighterrands.s3.amazonaws.com/The+Coldest+Days+mix/16+My+Saviors+Face.mp3"
        ]
    },
    {
        "id": "NEx6",
        "name": "Egomania",
        "artist": "Leo from Vermont",
        "date": "2010",
        "description": "Waxidermy mix swap 2010",
        "image": "https://nighterrands.s3.amazonaws.com/Egomania+Mix/egomania3.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Egomania+Mix/egomania.png",
        "section": "collage",
        "audio": [
            "https://nighterrands.s3.amazonaws.com/Egomania+Mix/egomania-comp.mp3"
        ]
    },
    {
        "id": "NEx7",
        "name": "Sunburned Skyline",
        "artist": "Leo from Vermont",
        "date": "February 26, 2018",
        "description": "Y'know, by the end of that first dawn... \nLost a hundred men. I dunno how many sharks. Maybe a thousand. I dunno how many men, they averaged six an hour. On Thursday mornin', Chief, I bumped into a friend of mine, Herbie Robinson from Cleveland- baseball player, boatswain's mate. I thought he was asleep, reached over to wake him up... \nbobbed up and down in the water just like a kinda top. Upended. \nWell... \nhe'd been bitten in half below the waist. Noon the fifth day, Mr. Hooper, a Lockheed Ventura saw us, he swung in low and he saw us. Young pilot, a lot younger than Mr. Hooper. Anyway, he saw us and come in low and three hours later, a big fat PBY comes down and start to pick us up. \n\nY'know, that was the time I was most frightened, waitin' for my turn. I'll never put on a life jacket again. So, eleven hundred men went into the water, three hundred sixteen men come out, and the sharks took the rest, June the 29th, 1945. \n\nI value my neck a lot more than three thousand bucks, chief...",
        "image": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/sunburned_skyline.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/sunburned_skyline-small.jpg",
        "section": "album",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/01-BEGIN(end)-comp.mp3",
                "title": "BEING(end)"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/02-Thoughtful-comp.mp3",
                "title": "Thoughtful"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/03-Quietly-comp.mp3",
                "title": "Quietly"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/04-Contented-comp.mp3",
                "title": "Contented"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/05-Chill+AF-comp.mp3",
                "title": "Chill AF"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Sunburned+Skyline/06-(begin)END-comp.mp3",
                "title": "(begin)END"
            }
        ]
    },
    {
        "id": "NEx8",
        "name": "Satta Down Sound",
        "artist": "Leo from Vermont",
        "date": "2018",
        "description": "Promotional mix for Buch Spieler records. Unreleased.",
        "image": "https://nighterrands.s3.amazonaws.com/Satta+Down+Sound+Mix/satta.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Satta+Down+Sound+Mix/satta-small.jpg",
        "section": "mix",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Satta+Down+Sound+Mix/01-sidea.mp3",
                "title": "Side A"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Satta+Down+Sound+Mix/02-sideb.mp3",
                "title": "Side B"
            }
        ]
    },
    {
        "id": "NEx9",
        "name": "Screwtape",
        "artist": "Leo from Vermont",
        "date": "2015",
        "description": "The soundtrack to some Houston DJ sweating through a codeine_fueled fever dream in the back room of an old record shack in Kingston, Jamaica. Think warm Wray & Nephew ovenproof rum, day old fried plantains, fresh cut mango. A candy dish full of Busta and crumbs of choice homegrown. This man's seen fire. He's seen rain. But he's gonna crush this shit, word too Mrs Ivy. \nBlessings.",
        "image": "https://nighterrands.s3.amazonaws.com/Screwtape/screwtape.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Screwtape/screwtape-small.jpg",
        "section": "collage",
        "zine": "Z01",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Screwtape/screwtape-a-comp.mp3",
                "title": "Side A"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Screwtape/screwtape-b-comp.mp3",
                "title": "Side B"
            }
        ]
    },
    {
        "id": "NE001",
        "name": "Somnium",
        "artist": "Leo from Vermont",
        "date": "March 28, 2016",
        "description": "A Side: \n[stage I] Restlessness \n[stage II] Apprehension \n[stage III] Placidity \n\nB Side: \n[stage IV] Deep Sleep\n\n\nSomnium's genesis was an attempt to be a journey through the stages of sleep, following a period of personal turmoil. Sleep is one of the most important components of mental health, and the disorders of sleep often are prelude and epilogue to events of mental illness. Living through prolonged events of sleep disturbance can be akin to living in a lucid dream, or an unending waking nightmare depending on circumstance.  Sleep and sleep mechanics are of great interest to me and having my own experience with the disintegration of sleep taught me an enormous amount about not only myself but the fragility of our mental heath.  It is a time and feeling state I hope to never suffer again but am glad I was able to tolerate and endure. This record is an attempt to recreate the noise in my mind, the fear in my soul, and the eventual peace that came at the end of the journey. I hope it finds you well…\n\nStage one of sleep, also known as the transitional phase, occurs when one finds themselves floating in and out of consciousness. During this NREM stage, you may be partially awake while your mind begins to drift off. This period of drowsiness eventually leads to a light sleep. This is also the time when the muscles jerk, followed by a falling sensation that jolts you back into consciousness. This experience is known as hypnic myoclonia.\n\nStage two is also a non-REM phase and is one of the lighter stages of sleep. Even though it is a light stage, the heart rate begins to slow and the core body temperature decreases. During stage two, eye movement stops and brain waves slow with the occasional burst of waves called sleep spindles. Stage two can also be characterized by the unstructured periods that alternate between muscle tone and muscle relaxation.\n\nStage three is where deep, slow brain waves known as Delta Waves begin to emerge. It is a transitional period between light sleep and a very deep sleep. Your blood pressure will start to drop. Stages three and four are also the stages during which you are most likely to experience sleep walking and night terrors.\n\nStage four sleep is where slow delta brainwaves will occur and your blood pressure will continue to drop. It's very difficult to rouse someone from deep sleep and, if you do awaken suddenly from this stage, you may feel groggy and disorientated for quite a while. This is the sleep stage where your body will repair itself and it can last for up to an hour; during this stage hormones such as Human Growth Hormone are released and the blood supply to your muscles will increase. This stage of sleep is also extremely important for immune system and general health.\n\n\nCredits:\nRecording and Mixing: <a class=\"ne-link\" href=\"https://www.instagram.com/leofromvermont/\" target=\"_blank\" rel=\"noopener noreferrer\">Leo From Vermont</a>\nMastering: <a class=\"ne-link\" href=\"https://www.instagram.com/m_geddes/\" target=\"_blank\" rel=\"noopener noreferrer\">M. Geddes Gengras</a>\nArt: <a class=\"ne-link\" href=\"https://www.instagram.com/televista/\" target=\"_blank\" rel=\"noopener noreferrer\">Jeff Rochester</a>",
        "bandcamp_url": "https://nighterrands.bandcamp.com/album/somnium",
        "image": "https://nighterrands.s3.amazonaws.com/Somnium/somnium.jpg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Somnium/somnium-small.jpg",
        "section": "album",
        "zine": "Z03",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Somnium/somnium-a-comp.mp3",
                "title": "[stage I] Restlessness, [stage II] Apprehension, [stage III] Placidity"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Somnium/somnium-b-comp.mp3",
                "title": "[stage IV] Deep Sleep"
            }
        ]
    },
    {
        "id": "NEx10",
        "name": "Green Mystery",
        "artist": "Cosmic Joe",
        "date": "July 2019",
        "description": "The soundtrack of a dog hunting beans.",
        "image": "https://nighterrands.s3.amazonaws.com/Green+Mystery/thegreenmystery.png",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Green+Mystery/thegreenmystery.png",
        "section": "mix",
        "zine": "Z02",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Green+Mystery/GRNMYSTA-comp.mp3",
                "title": "Side A"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Green+Mystery/GRNMYSTB-comp.mp3",
                "title": "Side B"
            }
        ]
    },
    {
        "id": "NE002",
        "name": "abandoned tiki bar",
        "artist": "East Coast Tropicals",
        "date": "March 2020",
        "description": "Abandoned Tiki bar arrived in our mailbox along with a message from the Static Breakfast ensemble. It was a pocket dial I'd guess, muffled, and I could only make out one voice, but as best as I can make out here's what it said:\n\n\"Now that's strange.\n\nI could have sworn this was the place. It looks the same, but something changed. Something is, uhh, I'm not sure of the best way to say it. Wrong?  I'm not sure that's exactly right. Something is different, that's probably more like it.\n\nYeah, last time we came it was a blast. All the same vintage Hawaiian style decorations, funky drink glasses, and wacky drink specials. Yeah, totally, those little umbrellas and all that shit haha. Our waitress was hilarious. And it was pretty cheap! They played that Santo and Johnny song like 8 times. What's it called? Yeah, sleep walk. That's definitely it.\n\nYou see the bartender? Yeah that's him. Let's see if he knows what's up. Hey. Hey! Can I get a drink? Huh. Maybe he can't hear me...\n\nWanna bounce? Yeah, let's go up the street. I'm getting creeped out. Plus it's freezing in here.\n\nYou smell that? Nah, nothing. Don't worry about it. Yeah, sure. Oh, ok. I'll just catch you later. Totally, see you in a bit...\"\n\nCryptic messages and mysterious happenings are only some of the vibe in the 'Abandoned Tiki Bar.' It's the place this music is of, and for, and the place few want to find themselves. But a few do. And it's to those unique individuals this tape is dedicated.\n\nGood luck and stay safe out there. ",
        "image": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/cover.png",
        "image_preview": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/cover.png",
        "bandcamp_url": "https://nighterrands.bandcamp.com/album/abandoned-tiki-bar",
        "section": "album",
        "zine": "Z04",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/1-comp.mp3",
                "title": "a lingering spell"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/2-comp.mp3",
                "title": "deep end"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/3-comp.mp3",
                "title": "wax fruit"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/4-comp.mp3",
                "title": "gregorian"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/5-comp.mp3",
                "title": "midnight flavor"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/6-comp.mp3",
                "title": "fogcutter"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/7-comp.mp3",
                "title": "desert detour"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/8-comp.mp3",
                "title": "kokomo fumes"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/9-comp.mp3",
                "title": "puka"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/10-comp.mp3",
                "title": "indoor koi pond"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/11-comp.mp3",
                "title": "conga line ghosts"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/12-comp.mp3",
                "title": "bwana boa"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/13-comp.mp3",
                "title": "flotsam cargo"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/abandoned+tiki+bar/14-comp.mp3",
                "title": "lost theme of venus"
            }
        ]
    },
    {
        "id": "NEx11",
        "name": "Say his Name",
        "artist": "Leo from Vermont",
        "date": "June 2020",
        "description": "Dear world:\n\nAs a white person of privilege I've been struggling with what to do about this (and so many other) tragedies, and how to help in the inspiring response by people taking to the streets to demand justice. As was put so eloquently by Josiah Steinbrick, we can't make this about people like me, we need to give space to other voices. But I felt like I needed to do something. So I went through the mountains of African American music I've been fortunate enough to have shared with me from a staggering variety of sources and made a mix tape to try to help.\n\nI've done my best to be sensitive to the cultural appropriation inherent in any such endeavor, but please know I did my best to present these voices and music in a way that made sense. Side A is mostly music with vocals/poetry while side B is more often instrumental, with exceptions.\n\nI was watching on twitter etc as everything was happening and I was working, so I used audio live streamed from various protests on the mix. Thank you to all the brave people out there doing good.\n\nLet's all take care of each other.",
        "image": "https://nighterrands.s3.amazonaws.com/Say+his+Name/image0.jpeg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/Say+his+Name/image0.jpeg",
        "bandcamp_url": "",
        "section": "mix",
        "zine": "",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/Say+his+Name/sayhisename-sidea.mp3",
                "title": "Side A"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/Say+his+Name/sayhisname-sideb.mp3",
                "title": "Side B"
            }
        ]
    },
    {
        "id": "NE003",
        "name": "SKRW II",
        "artist": "Leo from Vermont",
        "date": "October 14 2022",
        "description": "It was born deep in a basement house party, circa 1996. As far as unlikely outposts go, Vermont might as well be outer space. But the mighty John Demus hit the turntables, joyride riddim thumping. We were surrounded by bashment girl, the cheap bottle of E&J almost gone, and it was on. Quick slide through ganja pipe with the buccaneer, then it all crashed. First bars of lodge blew the minds clean out of the skulls of the youth, and the path was clear. Shit, Babylon thumping on the door. I didn’t even know what that meant. But FUCK that, lock it up, throw on grass cyaat and settle. Can’t let them kill the vibe.\n\nNext night, red solo cups, three blocks down. Then the next. Cool rulers ruled, but it was soon forward. Time moved along, but the precedent was established. An elder dread once told me you never break up a riddim, you RUN a riddim. So we ran with it. Mixtapes, mix CDs (remember when that seemed like the future?), so many sets, and the top was the late night sessions. 151 always seemed like a good idea, and Dubie could make it work. It always felt right. But then Infinite went in. The only constant was change.\n\nBut look at me, trying to wax poetic about sweaty basement parties in dirty apartments with the locals. I’m not glorifying it, because that would be fake, but it was fun as hell.\n\n\nSKRW II was a second life for the first Screwface tape. A taste of dubbed out island life from the depths of Duxbury. Sent out to the Waxidermy massive to little fanfare, it was a shot at recreating the feeling of those long walks home from aforementioned parties, often through the woods with Adam to avoid Burlington’s finest. Only the meek get pinched, the bold survive. Those nights changed the way I felt about music, of all forms and fashions. We run tings, tings nah run we.\n\nThis new tape is less a nod to the past but more a look at the future, with a hand held out to friends new and old. Ged Gengras made the master sing in a way we never could alone, I’m forever in his debt. I Jahbar and G Sudden lend endless hype to the beginning and end of the tape, a blessing from the Duppy Gun crew that inspires us every time we create. It’s an honor to be in the family.\n\nAll profit from this release will go directly to the Duppy Gun studio in Kingston, Jamaica. Let’s build. We hope this is merely the first collaborative release and we continue to vibe from here. Ever forward fam…\nJah Meditation Sound &\nLeo from Vermont &\nThe NightErrands crew ",
        "image": "https://nighterrands.s3.amazonaws.com/skrw2/skrwii.jpeg",
        "image_preview": "https://nighterrands.s3.amazonaws.com/skrw2/skrwii.jpeg",
        "bandcamp_url": "https://nighterrands.bandcamp.com/album/skrw-ii",
        "section": "album",
        "zine": "Z07",
        "audio": [
            {
                "file": "https://nighterrands.s3.amazonaws.com/skrw2/SKRW+2+SIDE+A+MASTER+V1.mp3",
                "title": "side a"
            },
            {
                "file": "https://nighterrands.s3.amazonaws.com/skrw2/SKRW+2+SIDE+B+MASTER+V1.mp3",
                "title": "side b"
            }
        ]
    },
    {
        "id": "NE004",
        "name": "Transifiguration",
        "artist": "Old Gold",
        "date": "October 18 2026",
        "description": "It was war.\n\nNever mind the time, nor the place, realm, region, or reality. It was WAR. It had always been war, and henceforth it was understood that it always shall be.\n\nAsk you who fought this war, and how, and even the most dangerous of these, the dreaded why, you will receive many answers. Yet they are all wrong.  The war was fought because the war had to be fought. It simply HAD to be. Everything else was just confabulation. This war was a desire that came from the hearts of the warriors on all sides. It knew, yet not in words, that a conflict was not only inevitable, but it was RIGHTEOUS.\n\nThe cowards and failed combatants claim that this conflict only amounts to a philosophical dystopianism belayed by a mere pinch of spiritual egress. Fair enough. But such ideas always come from the disheartened and desolated. Yet I digress.\n\nThe origin story of this war began with the seed planted in a small record shop. It knew not of its import, only of its mission. That mission was to merely put weapons in the hands of those who would wield them. There was no attempt to explain how one might put them to use, nor when, nor why.  Luckily many of these weapons made it to the precious few who could use them.  And while many used them, and even fewer used them well, even less had the skills necessary to make them SING.\n\nAnd sing they did, through the longest days, the darkest nights, the weeks, the months, the years, and the millennia. There is no history written of this war, because it neither has a beginning nor an end.  But songs were sung, and shall be sung, and THAT will have to do.\n\nThese warriors were of many shapes, sizes, colors, and creeds. They arrive to battle in full finery, shields and swords glittering with the power of a dozen Suns. Or they may appear festooned with the scars and stains of decay, with eyes of steel and hearts of ice. Warriors should not be judged, for good or ill, by the shine of their armor nor the rich dyes of their regalia.\n\nWe together, nonetheless, must acknowledge a truth:  ONLY AT YOUR OWN PERIL should one underestimate a warrior who arrives with neither pomp nor circumstance, with plates that show signs of many battles, as those are often wielded by the truest of masters. Proper respect MUST be given.\n\nIt is these warriors who are the muse for which we, at night errands, toil. As it is, again, and forevermore shall be, these brave souls who fight in this righteous war.\n\nHere we humbly present some of these songs for you, from one of these masters, adorned only in the simplest of garments.\n\nWe only ask that if you choose to use them, you use them well ✌🏼",
        "image": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/Transfiguration+FRONT+Final+-+RGB.jpg",
        "image_preview": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/Transfiguration+FRONT+Final+-+RGB.jpg",
        "bandcamp_url": "https://nighterrands.bandcamp.com/album/transfiguration",
        "section": "album",
        "zine": "",
        "audio": [
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/1.Transfiguration+%5B2026-09-09+180127%5D.wav",
                "title": "Transifugration"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/2.FiringLine+%5B2026-09-09+180159%5D.wav",
                "title": "Firing Line"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/3.WaveIndex+%5B2026-09-09+180200%5D.wav",
                "title": "Wave Index"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/4.TheHardWay+%5B2026-09-09+180202%5D.wav",
                "title": "The Hard wayward"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/5.Curse%231+%5B2026-09-09+180203%5D.wav",
                "title": "Curse #1"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/6.BushBonez+%5B2026-09-09+180205%5D.wav",
                "title": "Bush Bonez"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/7.Curse%232+%5B2026-09-09+180206%5D.wav",
                "title": "Curse #2"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/8.SmokeBelly+%5B2026-09-09+180207%5D.wav",
                "title": "Smoke Belly"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/9.Survival+%5B2026-09-09+180208%5D.wav",
                "title": "Survival"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/10.CoalCode+%5B2026-09-09+180209%5D.wav",
                "title": "Coal Code"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/11.AntrimCrateChallenge+%5B2026-09-09+180211%5D.wav",
                "title": "Antrim Crate Challenge"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/12.CookWanniganCurls+%5B2026-09-09+180212%5D.wav",
                "title": "Cook Wannigan Curls"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/13.KillShotRevelation+%5B2026-09-09+180214%5D.wav",
                "title": "Kill Shot Revelation"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/14.BigWalt+%5B2026-09-09+180215%5D.wav",
                "title": "Big Walt"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/15.Curse%233+%5B2026-09-09+180217%5D.wav",
                "title": "Curse #3"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/16.LoveBite+%5B2026-09-09+180218%5D.wav",
                "title": "Love Bite"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/17.ResearchLibraryBlackout+%5B2026-09-09+180219%5D.wav",
                "title": "Research Library Blackout"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/18.HandToHand+%5B2026-09-09+180220%5D.wav",
                "title": "Hand to Hand"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/19.LunarCut+%5B2026-09-09+180222%5D.wav",
                "title": "Lunar Cut"
            },
            {
                "file": "https://nighterrands.s3.us-east-1.amazonaws.com/Transfiguration/20.AstrovanDreamRetreat+%5B2026-09-09+180222%5D.wav",
                "title": "Astrovan Dream Retreat"
            }
        ]
    }
];

export function getReleases() {
	return releases;
}

export function getRelease(id) {
 	return releases.find(
 		r => r.id === id
 	);
}

const artists = [
    {
        "id": "leofromvermont",
        "name": "Leo From Vermont",
        "description": "When Leo was a boy one of the few VHS movies in his folks humble collection was a copy of mean streets. That along with Swiss Family Robinson, SNL, and your garden variety dreck. Has anyone ever actually watched the longest day? Seriously. I ask you. But anyway, things happen to a boy exposed that much Harvey Keitel that early in life. No amount of wizard of oz can bring you back, not even if you are a dandelion.\n\nMusic came next, and soon the spikor and snake eyes were replaced by some combination of Thriller, Oliver and company, and we're not gonna take it. It was records of course but only because they were way cheaper than tapes or cd's. It was the 80's after all, you could still get Nike's out of a random bin on the floor of Gaines.\n\nOne day a kid named Jeff played Leo a dubbed copy of the blueprint three seats up from the back of the bus, and that bullshit was OVER. Never was he able to walk by a grounded bottle of Snapple the same way again. I still miss Scott LaRock. Then DMC. Then PRT. They were native till the end now-a-days they don't even speak. Prince Paul. Kool Keith. Company flow ruined everything. But they also saved everything. Build and destroy. Then radio. Then video. One night in a basement with John Demus and a bottle of E&J changed everything. But I digress...\n\nThere are few sadder scenes than a 20 something fat kid in a Fila jump suit and John Wallace Kani kicks with one leg pulled up at a weekly hip hop night at shithole called the bottle neck. But that kid was living the dream. And NO I don't have 'the gambler' how long have you been here? Have you heard anything that sounds even remotely like that song? Fuck.\n\nFast forward to today and all he wants to do is have a little fun before he died. That and a little Boko-Maru.\n\nTruth be told, in the end he turned out to be a fuckin' mook after all.",
        "image": "https://nighterrands.s3.amazonaws.com/images/artists/leofromvermont.jpg",
        "featured_releases": [
            "NEx9",
            "NE001",
            "NEx6"
        ]
    },
    {
        "id": "siamese",
        "name": "Siamese Faith Healers Network",
        "description": "The Siamese faith healers network started as a privately unprofitable organization on the mean streets of Manchester. Slowly toiling in obscurity, making records nobody listened to and even fewer heard, they persevered.  The crew would hit the international and exotica bin of the local record and/or junk store while other kids their age were out smoking cigarettes and playing portishead cassettes.\n\nHalcyon days of wasted youth full of coal miners lung, vegan rice dishes flavored with aminos, and the island of forgotten toys that was their record totes. But from the ashes the network continued to rise.  Many records later they were rescued from their communal ergonomic dog bed by the crew at night errands. They played us their old shit from a broken iPod on some shitty gateway computer speakers and we were hooked. Welcome to the monkey house, come on in, the water is fine.\n\nTheir sound is equal parts Les Baxter, hung over Double Dee and Steinksi, the Bermuda Strollers, Prince Paul on qualudes, ehh, and, well, MORE Baxter I guess. These fools play black moth super rainbow at dinner parties and weep softly when they hear 'sleep walk' by Santo & Johnny. I'm sorry Mrs Yancey, your boy deserves better.\n\nPour yourself a tall warm glass of coconut rum and feel the humidity. No shoes, no shirt, no idea how we got to this bar on a Wednesday with equal parts bad intentions and misguided faith in humanity.  But I'll have another, sure, what the hell. ",
        "image": "https://nighterrands.s3.amazonaws.com/images/artists/siamese.jpg",
        "featured_releases": [
            "NE002"
        ]
    },
    {
        "id": "cosmicjoe",
        "name": "Cosmic Joe",
        "description": "What pheonix can rise from the acrid smoldering badlands that constitute the modern suburban wasteland?  I'm still trying to find that out, but Joe probably doesn't know either.\n\nThey say blood is thicker than water, and in this case that is probably immaterial. But the uncanny resemblance Joe bore to the first born of record label stalwart Leo from Vermont warmed us to the lad and henceforth he joined our merry band of woebegone cooks. One day he will regret it, but for now what the hell, he's family.\n\nHe arrived fully grown yet newly adulted and returned to Vermont with a head full of Carly Rae Jepsen and a pocket full of kryptonite. He proved preternaturally adept at deciphering subway terror alert levels and acquired a dangerous taste for becks. A cruel mistress indeed...\n\nWhat the winds hold for our young squire is still to be seen, but with a future so bright, he better wear shades. That or risk some sort of corneal scarring. And nobody wants that.",
        "image": "https://nighterrands.s3.amazonaws.com/images/artists/cosmicjoe.gif",
        "featured_releases": [
            "NEx10"
        ]
    },
    {
        "id": "oldgold",
        "name": "Old Gold",
        "description": "The age of gold doesn’t matter a whole lot in strictly monetary terms. Something fresh from the earth weighs out the same for melt as a Drachma or a Krugerrand or whatever. But while pawn shop owners and grifters mostly don’t care for history or aesthetics, true numismatists can wax poetic about what specific boons a Doubloon has over mere pieces of eight. \n\nThus born into a musical family our hero learned to discern a bullshit 2009 walking liberty from pirate treasure, and decided upon a life at sea. \n\nRaised on a variety of musical styles, the OG always heard the music underneath the music. The pulse, as it were, that drove everything from piano solos to dirt head classic rock solos. Just Blaze had the password to his account, but much like Che Guevara with bling on, it was complex. The ocean can get rough, and it did. The winds can change, and they would. But that trusty compass always got him to shore. \n\nWhile in school, instead of football and student council he chose mtv music generator and a skateboard to fight the doldrums and indignities of a system designed to churn out cogs. Fuck all that noise, the man had work to do. \n\nTechnology served as his mast and riggings, and whether surfing through MIDI, crawling on some DAW, or tinkering with various samplers and keyboards it always drove the work. The sp 404, for him, like so many others, proved to be just the wind that his sails needed, particularly when trying to swing like Premo or blow life into the machine like Dilla. He learned much from the many other cloyed and apathetic ship masters he met before moving to the mountains for some well earned rest. \n\nSo here he is. Our world weary traveler, sea legs stiff from the trails, trials, and tribulations that brought him here. Now he spends his time listening to the music of the mountains, the melodies of the wind, and the solos of the deep evening quiet. The oldest gold has a deeply rooted soul, and that’s what he brings to his music. He’s seen the wars, reported his findings, and pressed send. And the journey isn’t over, it’s only just begun. \n\nAs he is fond of saying, “The spark is the guide, and I am conducting a never ending investigation to guard the spark.”  Aye aye skipper, the mission is clear, we got your back. \n\nMy Fellow Americans, we at nighterrands say  with the utmost pride and sincerity that we present his recordings as a living testament and recollection of history in the making during our generation.",
        "image": "https://nighterrands.s3.us-east-1.amazonaws.com/images/artists/oldgold.jpeg",
        "featured_releases": [
            "NE004"
        ]
    }
];

export function getArtists() {
    return artists;
}

export function getArtist(id) {
    return artists.find(
        a => a.id === id
    );
}

const zines = [
    {
        "id": "Z07",
        "title": "SkrwIIZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/01.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/04.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/06.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/08.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/09.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/10.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/11.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/12.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/13.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/14.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/skrwiizine/15.jpg"
            }
        ]
    },
    {
        "id": "Z06",
        "title": "NeoZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/01.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/03.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/04.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/05.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/06.png"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/07.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/08.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/09.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/10.png"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/11.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/12.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/13.jpg"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/14.png"
            },
            
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/15.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/16.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/17.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/neozine/18.jpg"
            }
        ]
    },
    {
        "id": "Z05",
        "title": "ESPZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/0.JPG",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/0.JPG"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/00.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/04.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/06.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/08.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/09.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/10.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/11.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/12.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/13.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/14.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/15.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/16.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/17.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/18.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/19.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/20.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/21.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/22.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/23.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/espzine/24.jpg"
            }
        ]
    },
    {
        "id": "Z04",
        "title": "TikiZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/01.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/04.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/06.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/08.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/09.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/tikizine/10.jpg"
            }
        ]
    },
    {
        "id": "Z03",
        "title": "MoonZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/01.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/04.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/06.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/08.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/moonzine/09.jpg"
            }
        ]
    },
    {
        "id": "Z02",
        "title": "GreenZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/01-small.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/01.jpg",
                "small": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/01-small.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/02.jpg",
                "small": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/02-small.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/04.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/06.jpg",
                "small": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/06-small.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/08.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/greenzine/09.jpg"
            }
        ]
    },
    {
        "id": "Z01",
        "title": "ScrewZine",
        "date": "",
        "preview": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/preview.jpg",
        "pages": [
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/01.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/02.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/03.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/04.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/05.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/06.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/07.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/08.png"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/09.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/10.jpg"
            },
            {
                "full": "https://nighterrands.s3.amazonaws.com/images/zines/screwzine/11.jpg"
            }
        ]
    }
];

export function getZines() {
    return zines;
}

export function getZine(id) {
    return zines.find(
        z => z.id === id
    );
}

const thoughts = [
    {
        "id": "TH01",
        "title": "Diplomacy",
        "date": "June 2019",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/images/thoughts/madeline.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/thoughts/madeline-small.jpg"
        },
        "content": `We here at night errands have always dreamed of becoming the comptroller of Duxbury. One day that power will be within our grasp... With dreams such as those, we spend countless hours sharpening our wit with political leaders of all eras.
        
{{image https://nighterrands.s3.amazonaws.com/images/thoughts/madeline-small.jpg "Handshakes for business"}}

Here you can witness the night errands braintrust building with former Secretary of State Madeline Albright, a true Machiavelli.`
    },
    {
        "id": "TH02",
        "title": "Connections",
        "date": "December 2021",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/connections1/covers.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/connections1/covers.jpg",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/connections1/covers.jpg ""}}
{{audio https://nighterrands.s3.amazonaws.com/thoughts/connections1/snippets.mp3 "Snippets"}}

“You go out and you look in the sky. We live in this act of creation that is unfathomable and overwhelming. The intricacy, beauty, fearsomeness. We push back by becoming active, becoming producers, and putting our little pieces of creativity down next to it. It's this idea, I can do something, too." - Nathaniel Mackey

And so begins my writing career, and the night errands blog.

Here's what I'm thinking for this column currently titled <em>Connections</em>. We'll roughly trace a connection between four records, exploring the interesting (according to the author) components of each to varying extents. The malleability of these connections is left entirely to my discretion, however. Mutually unorthodox instrumentation? Sure. Cover art similarities? Yup. Two artists are both big Chicago Bears fans? Definitely. Basically anything my brain is capable of tying together is fair game, so strap in.

{{header "On the Corner"}}
This album is fantastic. So thick. Electric Miles is the best Miles (<em>In a Silent Way</em> is unimpeachable). What else is there to say that hasn't been said already? Our connection springs from some reading I was doing on the album while sitting on the couch deep in the thick of it. The Wikipedia page talks about how a big influence of Miles' during this time was Karlheinz Stockhausen. What? Miles would apparently drive his Lamborghini around playing a cassette of <em>Hymnen</em>, a two hour long work which stitches together national anthems of the world in this disturbing scanning-through-radio-stations collage. What??

{{image http://3.bp.blogspot.com/-tT_C3bk6fRI/UgNixEz0PmI/AAAAAAAACVA/aazhJwukE4Y/s1600/Miles-Davis-Red-1967-Ferrari-275-GTB4-Driving.jpg ""}}

I say "what" somewhat facetiously above, as this does in fact strike me as pretty standard Miles. I highly recommend his autobiography - it's loaded with fantastic stuff like that and on average every third word in the book is "motherfucker", so that's captivating to an extent. Anyway, off to Stockhausen.

{{header "Stockhausen"}}
This naturally led to me listening to some Stockhausen which I found pretty hit or miss. Some really cool shit in there - his top albums on Spotify contain some pretty good stuff. Incredible outer space music. The most vivid and descriptive percussion ensemble I've ever heard; at times the soundtrack of a petty criminal on the job, at times earth-shaking epics. I picked up this record purely for the Stockhausen name at Red Onion a bit ago. These contemporary classical comp albums are a new genre I'm starting to take the dive into. CRI seems to be a pretty good label for this stuff, and I'm growing more and more convinced anything in this era on Deutsche Grammophon is going to be awesome.

{{image https://idagio-images.global.ssl.fastly.net/albums/00028944743029/main.jpg?auto=format&dpr=1&crop=faces&fit=crop&w=720&h=720 "On the topic of Deutsche Grammophon... <em>Jeux d'eau</em> is perfectly flowing and free."}}

The Stockhausen track on this record is of questionable merit. Rough stuff. Not for me. I think it helps to approach this sort of music with the term sonics in mind - trying to focus on all the physics wave mumbo-jumbo components of sound. Doesn't always work. The more interesting track on this album for me is the version of <em>Threnody to the Victims of Hiroshima</em> which I recognized from the completely bonkers episode of Twin Peaks where David Lynch forces the viewer to experience nuclear fission (as I write this, I think of a secondary connection to our third record which we will explore later). That third season is so wonderful - currently reflecting with joy on our time with <a class="ne-link" href="https://www.vulture.com/2017/06/twin-peaks-in-praise-of-dougie-jones.html" target="_blank" rel="noopener noreferrer">Dougie Jones</a>.

{{embed "<iframe src="https://player.vimeo.com/video/229621231?h=c579f5522a&color=ffffff&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>"}}

Not all of Stockhausen's stuff I've listened to so far has clicked with me, or hasn't clicked yet. Stockhausen and his work did, however, become the jumping off point for our next connection by initiating my foray into this so-called New Music and Stockhausen's peer, Luigi Nono.

{{header "Nono"}}
Because this is generally such aesthetically challenging music, I find any appreciation of Nono's music divorced from the context of his life and beliefs to be impossible (and I'd bet Nono would say the same), so I'll try to provide some of the important details. I'm not going to do this justice, go read his Wikipedia and some liner notes, it's truly fascinating, but I'll try to set the hook. Centrally, Nono was a member of the colloquial Italian Resistance, a group opposing Italian and German fascist leadership in the mid-twentieth century. Considering what we know of that time period, I'm sure you can see how composing music while holding these beliefs in that era could lead toward an abandonment of the traditional beauty in music. When joy and beauty have left the world, shouldn't our music reflect that?

Nono's compositions must be contextualized through this political lens. He would often lecture and perform his pieces in trade unions and factories in an effort to captivate the working class. He contributed anti-imperialist articles to political journals. He believed in art that was both reflective of and rooted in the common reality of the masses. You know, this makes me think of the core principles of Peter Schumann's Bread and Puppet Theater. Great stuff over there as well, like costumed groundskeepers who force everyone in the audience to give them a little wave. And zebra chases. And singing beans who are rude to one another. And various other circus shenanigans.

As an example of this political context being made explicit in his work, consider Nono's attribution of the decomposed recordings used in <em>A Floresta É Jovem e Cheja de Vida</em>: "eleven moments of the anti-imperialist struggle, of reflection, of difficulty, of defeat, of lament, of conscience and of determination to continue the harsh and long struggle, of questioning." Heavy stuff! The eponymous text of that composition is pretty powerful; it is a quote from an Angolan guerilla fighter: "they cannot burn the forest for it is young and full of life." And so the struggle continues. Another referenced text for <em>A Floresta...</em> is Herman Kahn's escalation ladder, presented in what I have to assume is Nono saying, "just get a good look at the absurdity of all this." I found out while following this thread that Kahn was the inspiration for Kubrick's Dr. Strangelove. How's that for a tidbit? Hey! Guess what? This is the secondary connection I was thinking of earlier - nuclear fission & escalation ladder. This connection is very strong, Brandon Sanderson would approve (and perhaps even call it a Connection?).

{{image https://nighterrands.s3.amazonaws.com/thoughts/connections1/escalationladder.jpg "Could we stay at 0 please?"}}

Hopefully this is enough to leave you inspired to give Nono's music a try. I don't think there's anything insightful for me to say about the composition or substance of his music, but I do know what it evokes for me: this is devastated music, by a devastated human, from a devastated era. If you can summon up the acceptance and empathy to immerse yourself in it, it is immensely captivating and absolutely aching with pain. Truly music for a post-war depression.

{{image https://nighterrands.s3.amazonaws.com/thoughts/connections1/nono.jpg "Devastated... I feel like this is the look I get when a quesadilla flip goes awry"}}

And now to prove that this isn't all going to be seriousness and that our connections can be as arbitrary as I like, allow me to transition from all of this into a Godzilla movie soundtrack.

{{header "Godzilla"}}

Godzilla fighting Mothra from Italian World War II resistance. Bam. This record has such a fantastic cover. I love to picture some Japanese dude in this elaborate Godzilla costume standing around slapping some other Japanese dude in this elaborate Mothra costume. Wow they must have had a blast filming that. Thanks to some generous translation work from <a class="ne-link" href="https://www.instagram.com/sanonagai/" target="_blank" rel="noopener noreferrer">Sano</a>, I've learned that this is the third of a ten volume set of soundtracks from sci-fi movies. The three movies for this record are Mothra vs Godzilla, Giant Space Monster Dogora, and Giant Space War. What a trio! Such grandeur. I hope Earth survives all these giant monsters and space conflicts. Regarding the music, I wish it was a little more sci-fi and a little less "theme". Would one synthesizer really have broken the bank here? Those costumes are so high budget, I'm sure you can afford a Moog. Regardless, still well worth what I gave a dude wearing a flat cap at the Silver Spring record fair to get this one.

{{image https://nighterrands.s3.amazonaws.com/thoughts/connections1/godzillanooo.jpg "The snippet provided is from a track called <em>Godzilla's Revenge</em>. I like to think it soundtracks this moment: 'Get up Godzilla! We believe in you!'"}}

Thanks for enduring all that. Tune in next time - I promise I'll definitely choose better music.
`
    },
    {
        "id": "TH03",
        "title": "Corrections",
        "subtitle": "(An absurd counterpoint to nobody in particular)",
        "date": "December 2021",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image0.jpeg",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image0.jpeg",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image0.jpeg "(Insert Photo 1)"}}

Records. Fucking records. They're everywhere around me and I never can stop myself looking for more. Despite all that effort in acquisition I also, ironically, never spend quite enough time with the ones I have. Even the ones I love. Particularly those “I'm gonna need an XXL coffin because I'm taking these with me” type albums (and 45's). I have no interest in psychoanalyzing myself, but I will occasionally drop some notes on a few favorites in the feed here and do a lil campfire sesh.

Round one: Check Out my Privates, vol 1 (aka digging stories about weird/cool records that are private/vanity pressings). 

{{header "Raymond Moody"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image1.jpeg "(Insert Photo 2)"}}
<em>Slum Flower</em> is the kind of record that I think about when I'm thinking about going to look for records. This was dug out of a classical bin in Burlington, Vermont many many years ago, at the old Recycle North on Pine street (RIP). Remember kids, never neglect the classical section, particularly in thrift stores. People file wild shit in there sometimes. This is one of those cases:

This record is poetry read by Raymond Moody, pressed to record after his untimely death. According to the back he became a drug addict at 17 and died on 20 December, 1968. He was from Newark, New Jersey, and must have recorded these poems onto a cassette recorder based on sound quality. The pain in his voice, the anguish, is so stark, and it's made even more immediate by the fact that you can hear traffic in the background as he reads. It's haunting but intimate, and absolutely kills me. 

His aunt Sadie wrote the liner notes and says, “Raymond was not a bad boy - he loved and wanted to be loved and liked by everyone. He was god's child but he lived in a bad neighborhood, the ghetto, and got involved with the wrong crowd.” It's a sad story about a sad reality, and unfortunately not a rare one. Songs like <em>Only if you would let me</em> and <em>Let me die, let me die</em> speak to the desperation. Raymond's ability to put these thoughts and feelings into poetry, however, is what makes this recording so special. 

His aunt concludes the liner notes by saying: “Raymond begged for help but it always came too late. So this is his first and last album.” And the world is the worse off for only having this one, and better for its existence. 

{{header "Prince (Skip) Farian"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image2.jpeg "(Insert Photo 3)"}}
I recently recounted the story of finding this record on Instagram, but I'll bore you with it here as well. I was in Jacksonville, the jewel of northern Florida, for a bachelor party some 15 or 20 years ago. My friend Joe, or “Navy Joe” as we used to call him, was getting hitched. It was an interesting group, pulled from many different, shall we say, “walks of life,” and as such was a shit show. But I mean that in the best possible way. The night ended in a Waffle House that had a liquor store in the back, and once you have those two details I probably don't need to finish this sentence.

I woke up next morning in a double bed in a hotel room with two giant good ol' boys snoring and sweating cheap bourbon all over me. I'll never look at bottle of Old Crow the same again. And I had one of those hangovers that only Bill Burroughs could effectively convey. Let me tell you though, it was FOR REAL. I knew there was only one thing I could do to make the pain stop, and that was go out in the sticky north Florida heat and look for some records. My bff Adam was down for the ride, so we left the snoring sweating mass of humanity and went looking for dirt malls. 

We made some very, shall we say, “interesting” stops along the way, but one was at what I believe they marketed as an “antique store,“ but in reality was a trailer with a long plastic tent next to it. More like a “semi-indoor yard sale“ I guess. There were a few piles of records, and I'm pretty sure one of them had a brown recluse spider in it, but it was all worth it when I saw this.

I don't know very much about Prince, but this record is a mix of modern soul with a West Indies feel, with a slight Christian leaning. It was released in 1980. Prince plays guitar and there's a whole series of backup instruments including electric piano, synthesizer, etc. While there are many good songs, <em>If you Believe</em> is a stand out, the best song on the album for me is called <em>Once again it's Christmas time</em> which I revisit most holidays. It's melancholy at it's best, and speaks to the struggles in that part of the world. The lyrics say it all: “Once again it's Christmas time, not everyone is doing fine, down in the ghetto people are suffering, down in the ghetto babies are crying, want some food to eat, in need of shoes on their feet.” 

HARD FILED. 

{{header "Cellutron and the Invisible"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image3.jpeg "(Insert Photo 4)"}}
This one is a doozy. And I'm cheating a little bit. Green Mountain records is a tiny little label in Northfield, Vermont. That is roughly somewhere between 15 and 28 miles from my house, depending on which way you go. The reason I say I'm cheating is that despite my proximity to the label, I've never even seen one of these anywhere out in the world. Not at a record show, not a record store, not in a thrift store, not anywhere else ever. I had to (sigh) buy this on the internet, despite the great shame in having done so. And now this is where I'm supposed to say “but at least I got a deal!“ but that would be a damn lie and I know it. Good news is I paid the “2003 going rate” as opposed to “now that VINYLS are back 2021 going rate.” So there's that I guess… 

I've always had a soft spot for records recorded in Vermont, and this is no exception. There are also a bunch of other cool records on this weird little label (which by rumor was eventually shut down under mysterious circumstances, I've never been able to get a straight story from anyone). If you see them they are generally worth the pittance they sell for, excepting the endless fiddler comps. Those can get tedious, at least to my untrained ear. 

This record, however, is the probably the coolest and most mysterious. Made by a man named Bob Greely, using state of the art 70's equipment like the Oberhiem digital sequencer and ARP 2600, as well as a host of other instruments, it's it's own unique universe. There is some rumor that Bob did the whole thing himself, and is potentially evidenced by the fact that most of the musicians are with credit names like “Indiana Straight” and “space boy” etc. Madlib would be proud, although as I write this I'm struck by the fact that he probably actually has a copy. 

It's psychedelic space music, owing both to progressive rock and the history of electronic music. With a name like <em>Reflecting On The First Watch, We Uncover Treasure Buried For The Blind</em> you know you need to buckle in. Think Nic Raicevic and Berlinger school noodling on mild psychedelics and all the weed they can get their hands on. It swirls and crashes and soars in equal intervals. Breathtaking combination of sound and feeling, probably at least partially due to the mix of digital and analog instruments. My favorite section is the B side, which starts with the song <em>Parisian Frequency Shift</em> which bleeds and squelches into <em>Reap the Whirlwind</em> before ending with a flourish that wouldn't be out of place on a keyboard demonstration record. And I say that as a compliment, just to be clear. 

The dedication says that this record was “inspired by the Holy Ghost.“
Amen to that, brother.

{{header "Jerry Farber Quartet"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image4.jpeg "(Insert Photo 5)"}}
A new addition to the collection. On a recent trip to New York to meet up with the cousin Country Joe, I stopped at one of the many little spots along the way. This one jumped out at me, having just hit the new arrival bin and being available for the “nice price,” as they say. 

Jerry Farber seems to be mostly in the mode of lounge-y jazz, and this record has a lot of covers, many of which are quite good. He does a decent version of <em>Comin' Home Baby</em> and <em>Moon Dance</em> as well as a few others. It's called “music for friends“ on the cover, although based on the music and the setting I imagine it's much more the “Hey! You know my friend Jerry? You remember Jerry right? No, Jerry! Good guy. Good guy. Next round on you? Beautiful!” spoken through smokey 7&7 breath just a little bit too close type friends. But I digress…

Back to the music. The real gems on this record are the songs featuring Stephanie Pettis on flute. Chief amongst those is their sick rendition of <em>Ain't no Sunshine</em> which goes on for four minutes and 52 seconds of pure fire. I think Bill would approve. It's on YouTube, so definitely worth looking up, but it's a soul jazz monster. I'm sure it's been compiled someplace, I'm not sure where as I didn't bother to Google it, but it's nice to have this in the original format. 

And it also must be noted that bass is played by Luelle Flavor, which is unquestionably the single greatest name for a bass player in the history of recorded music. 

The last song at first seems a touch out of place, it's a version of <em>Have Negilah</em> done jazzy lounge style. But that's why records are the best sometimes, as flipping the cover over can clarify things. In the loving description written on the back by Barry Farber (who is credited only as “WOR-AM TALK SHOW HOST) but I'd guess may be a relation. He lets us know that Jerry's “first public appearance was at his own bar mitzvah where he replaced a very bad piano player in setting with the band for the entire evening.” Being someone who insisted on DJing his own wedding, I immediately felt a kinship with the man. 

{{image https://nighterrands.s3.amazonaws.com/thoughts/corrections1/image5.jpeg "(Insert Photo 6)"}}

The record is signed on the back “To Laura and Bob Silverman. Hope you enjoy the sounds!”
I'm sure they did Jerry, and so do I.

Until next time,
LfV
`
    },
    {
        "id": "TH04",
        "title": "Mike's Choice Links",
        "subtitle": "Guest Spot",
        "date": "January 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th04/th04.png",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th04/th04.png",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/th04/th04.png "Vibes"}}
Robert Elliot Kahn. Tim Berners-Lee. William von Meister. Our beautiful, digital time capsule.

There's beauty in many things. Divinity too, if your philosophy is just right. The obvious: poetry, a third night moon, those first two weeks of spring, camaraderie. The obscure: closing time at the Moretown Store, watching the trains go by, green against gray, a shared understanding. Maybe I'm just ruminating about scale, concomitance, parallels? The internet loves scale.

Choice links, to me, is the art of finding that obscure beauty in this dumpster dive we call surfin' the web. I think there's also value in not really understanding what's going on at all. That militaristic shock and awe approach. I want to be left a bit dumbfounded by that link. But that's ego talking - you all know a choice link when you see one. And these are Mike's links, not mine, so go ahead and ignore everything I just said.

{{image https://nighterrands.s3.amazonaws.com/thoughts/th04/wow.png "Gettin' after it"}}
A wash of red. Low framerate. Youthful exuberence.
{{image https://nighterrands.s3.amazonaws.com/thoughts/th04/yup.png "Composition"}}
Low ceilings. A mediocre cameraperson. Humility.

This is a powerful link. It's hypnotic. There are so many wonderful factors combining to elevate this to the status of "choice". The contrast of the at times reckless abandon and the tender interstitial movements really gets me. Selector put on a true banger for this one (not to mention the audio still somehow being copyrighted by Sony Music). The whole thing being bathed in this wash of red light is truly the crowning piece. As of time of publish I would wager I'm responsible for at least 10% of the 364 views. After a frontloaded burst, this link has become a quarterly returner for me. The time off lets it simmer, giving me fresh insight for every revisit. And wow, do I get a lot from every viewing. The video description informs us that we're witnessing "Nikhil Karkhanis Solo dance competition performance". Nikhil, thank you for sharing your competition performance, it has brought me a lot of joy. Please enjoy this choice link.
{{embed "<iframe width="560" height="315" src="https://www.youtube.com/embed/RhNGTmzDYCI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>"}}
`
    },
    {
        "id": "TH05",
        "title": "Mike's Choice Links",
        "subtitle": "'Foord and Reilly",
        "date": "January 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th05/th05.png",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th05/th05.png",
        },
        "content": 
`
{{embed "<iframe width="560" height="315" src="https://www.youtube.com/embed/t0D6z-3KTCk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>"}}
Hey everyone, Mike here. Sometimes my Choice Link will be some choice HEMA commentary from the head trainer at Duxbury HEMA alliance. We're heading into dark times, people, and we should all be more proficient with a variety of blades for when duels are used to settle disputes.

'Foord, hey! Hey! A little bit with the overextension there, maybe try to keep more on center after a slice. Always finish in LongPoint or Reilly is going to eat your lunch.  Hey boys, make sure to have something planned beyond initially taking the Vor. You don't want Reilly to ruin your shirt there by poking a hole through it. Pretend he's a ridge runner who's trying to steal your pig. 

“You all right?”
“Yeah!”

Way to check in, good with the safety. Riley definitely gets the Green Mountain HEMA Dojo Good Sport award this week. What an honor. Sportsmanship is next to godliness.

Hey good buddies, your pluderhose are dank but I could probably grab a handful of them if we're playing dirty Green Mountain rules, so maybe hike those things up with a good cod piece. Make sure it's good'n tight so your pluderhose stay in place and I can't grab them and yank them off and then you lose the duel due to your bare butt hanging out.

Okay, despite all this praise, there's very little kicking and that's really disheartening. There's a lack of shoes, so I want to see more kicking. No reason not to kick. I mean, a shin kick is very painful, just make sure not to break your own damn foot. I guess if you've never kicked don't start now.

You guys are looking like you're sucking wind pretty bad already, maybe take a few laps after we're done, eh? It telegraphs your movement when you lead with your feet, fellas. I'm going to say it three times for every time you do it— what if a redneck is trying to take your farm?!

I'm going to need to see more zwerch. It's Meyer rapier, so you need to pretend you're a helicopter on the nachslag or Reilly is going to cut off the crusts, feed them to your dog, and eat your damn bologna sandwich that your mom made for you.

Fun fact, we sprang Reilly out of Medieval Times to come down to Night Errands studio and chat a little bit about the making of the video, but he had to cancel because he says his pluderhose got caught in his bike chain. That's why I always say you should drive a car to a duel.

Just a note about equipment at the dojo here, guys–You know, 'Foord, I'm not entirely sure you should be doing this bladework without gloves, and Reilly, I love you to death, but you've clearly had the whole bottle of blackberrry brandy and you're hacking like a real jerk.

Let's work on those kicks, and let's work on our problem solving; we shouldn't be doing violence to one another. Once we've all had a water break, let's get into LongPoint with your non-dominant hand, and tune into this recording:
{{embed "<iframe src="https://archive.org/embed/podcast_meditation-mindfulness-b_guided-relaxation-response-med_1000411319005" width="500" height="30" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen></iframe>"}}`
    },
    {
        "id": "TH06",
        "title": "Mike's Choice Links",
        "subtitle": "Thesis on Nightperson",
        "date": "January 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th06/th06.png",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th06/th06.png",
        },
        "content": 
`
{{embed "<iframe width="560" height="315" src="https://www.youtube.com/embed/BUa00AVC25k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>"}}
Night as construct, all the D-words that I'm not going to write, third-cousin to the day. They're related, but only tenuously. No worries about hemophilia within the hallowed confines of those nuptials; folks in the American south might call them kissing cousins, without realizing they're making an incest joke.

Intentionality, muse to both the night and the day, although typically borne of purpose decidedly different, is what makes a person of the night, a Nightperson.

Is this aforementioned person here to serve some sort of biological imperative, build something, bake bread, comfort the distraught? No. If one's purpose is focused toward growth, I postulate that their intentionality is not of the night.

The night time is for creeping into the kitchen while the house sleeps. Nightperson hears the gentle din of the refrigerator and does not know that they should stop, turn back, desist. They are not here.

The person who knows that it's a bad idea for them to eat vegan mayo with slices of gabagool while staring sightlessly into the dark kitchen is not the kind of person who does that sort of thing. The act offends the person of gentle sensibility and prosocial schema.

“Oh Jesus!” They might likely exclaim, while Nightperson slowly chews, coating his pallet with the 'gool.

Nightperson is unaware of sensible, prosocial schema. It is not a willful disregard, but a state of serene indulgence of the surroundings. Boundaries, say, between a significant other's special leftovers from their favorite restaurant, clearly marked with a note—don't eat this—and Nightperson's GI tract, simply aren't there. How could they be, if intentionality is of the night?

Nightperson is in a natural state of being, and one that can be selectively trained and harnessed to do great works that offend intentionalities aimed at growth and sensibility.

Our errands are many and varied. Our errands are not stagnant, for the God Emperor Leto II teaches that chaos must not be denied. The nighttime is distemporal, and harnessed for great works of offense.

Meditate on the impact on humanity that comes of Mr. Brown's treatise on the art of bottle decapitation. I challenge you to find growth or sensibility.

May the night silence your footsteps to the refrigerator, and render deaf all ears to the crinkling of noisome wrappers.`
    },
    {
        "id": "TH07",
        "title": "Connections",
        "subtitle": "",
        "date": "January 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th07/th07.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th07/th07.jpg",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/th07.jpg ""}}
{{audio https://nighterrands.s3.amazonaws.com/thoughts/th07/th07.mp3 "Snippets"}}
Today's themes: hater shit, refutation, spheres, tribal knowledge.
{{header "Sunset to Dawn"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/1642208922520.png "Ladies and gentlemen, on the weird clapper stick, Bob Crenshaw!"}}
This one right here. We've got a fair bit to unpack. First, Night Errands would like to acknowledge the relevance of our title, <em>Sunset to Dawn</em>. Perhaps a bit blunt, perhaps lacking Mike's finesse, but representative of our ethos nonetheless.

Carrying on, we're loaded up with proper tunes here - no gimmicks. No sad europeans. No space monsters. Just nice aesthetics. This isn't one of those oddity appreciation / sonic regret albums. It's just 40 minutes of Kenny tickling the ivory, reeds be damned. And Kenny's playing is really great too. I think my favorite aspect is his variance of urgency - really jumps between lolling about and ripping off Tatum-esque runs. The other elevating musical component here is definitely the percussion. It's a great injection of mystique. For me, that's what pushes this beyond the land of the square and into the realm of the rhombus.

Now, unexpectedly (for our recurring readers, perhaps expectedly), the substance of our exploration comes from the liner notes. I've always been fascinated by these back cover reviews on jazz albums. It seems to me like the antithesis of the modern marketing approach. Gary Giddins' work on this one is fairly archetypal, but it does contain some interesting stuff; what appears in the first light of day to be your bog-standard, Downbeat style fluff, reveals several tasty morsels for us under the black light of night. That's not to say there isn't plenty of Downbeat style fluff:

"Somewhere between the doddering old sycophant and the genius hipster is the dictum for social honesty, self-cognizance and original art. And of growth, if we can assume that growth - as opposed to mere change - must emanate from total sincerity." For some reason while reading this I felt it was good advice for anyone entering an emo phase: "It's not a phase, Mom. Gary told me what I'm doing is art!!!" Well said, Gary.

"An exemplary instance of Barron's growth since the early 60s is the way he subordinates formals design to linear invention." Yeah I definitely love that about Kenny too. Linear invention. Subordination and what not. The notes kind of fall apart when it gets into a discussion of the music instead of the musical context. Funny how that always seems to happen for me.

As alluded to above, my favorite bit of the liner notes is as follows: "All the musicians regrouped for the overdubbing of extra-rhythmic effects ... 'Time for kindergarten,' Bob Crenshaw announced as they prepared, each with something different to shake or hit or scrape." This is such a vibrant, joyful image in my mind. Bob has certainly regained that childhood naiveté we're all hunting after.

Our first <em>Connection</em> today comes from a more dubious section of the liner notes: "This version compares interestingly with the less successful one Kenny recorded with Yusef Lateef. Lateef's arrangement seems to set these nocturnal rituals in the Transylvanian atmosphere of wheezing bats and burping vampires." Wow - that does not sound like positivity to me, Gary. Let's ease up on the hater shit, Gary. This really caught me off guard on first read - I was certainly not in the mood for all that. 

Now you probably think we'll take the easy path here and jump on over to a Yusef record. Not today. No paths well traveled here at Night Errands. As much as the hater shit hurts my soul, that is the path we elect to follow today.
{{header "Nefertiti"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/PXL_20220115_014819091.jpg "FRB hates Bill Evans / I love Sunny Murray"}}
Cecil Taylor's liner notes here are the cannonball into the Haterade which Gary was merely soaking his feet in. I count 9 paragraphs of disdain for one Bill Evans across the gatefold. The most choice snippet:

"Evans has the right to go his own way, but I do not think his playing is a particularly powerful powerful argument for his thesis. I've heard him in clubs, and I know at least 10 pianists - without even thinking about it - who better deserve the amount of page space he gets. I can't take what he says too seriously because what I hear when he plays is so uninteresting, so predictable and so lacking in vitality. He's a competent cat. That's all."

God damn, Cecil.

Now, this obviously has to be read in the context of a defense of the avant-garde predilections of Cecil in 1965. Even so, I feel like he didn't have to go so hard. Besides,
{{image https://img.discogs.com/c1d6zbaDncGZP-Czf0I0wf1t13U=/fit-in/600x593/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-3416397-1466292229-8551.jpeg.jpg "A little bit indulgent, Bill"}}
Without any more of the author's bias on the debate, let's take a clandestine stroll down this well-trodden path and let you be the judge between these two and <em>Connect</em> on up with one "competent cat," Bill Evans.
{{header "Undercurrent"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/PXL_20220116_231133767_2.jpg ""You want me to play this? It's lacking in vitality!""}}
This was the first record I ever bought. One harsh Vermont winter visit filled with entirely too much, yet somehow not enough, Red Hen loaves finds us at Buch Spieler in Montpelier. I buy this and a green vinyl King Gizzard and the Lizard Wizard record which I subsequently return for having a skip. Yes, seriously. Yes, I still hold shame over it. Curse my ji'e'toh.

Bypassing my dishonorable behavior, this record was purchased partially because of the great cover and partially from being an adjacency in the Leo sphere of influence. At some point Leo played the Jim Hall / Red Mitchell record for me whilst pontificating about all the obvious silliness surrounding the two great musicians. Since that point I have permanently had Red Mitchell in deep bass meditation/trance/ecstasy plastered in my mind palace.
{{image https://img.discogs.com/Vs2t2S96vXGvhIil_e0o4V2mYNw=/fit-in/600x597/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-2634844-1294350431.jpeg.jpg "This is good enough reason for me to buy every Red Mitchell record I see from now on"}}
As I'm sure we'll explore many times in forthcoming articles, the Leo sphere of influence is an apparition that Night Erranders enjoy or endure, depending on who you ask. Some of us need more garlic, I suppose. Regardless, as our resident Grandpa Robocop, we all still maintain that healthy respect and love for Elder Leo.
{{header "Love You"}}
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/PXL_20220116_231543043.jpg "The year 2000"}}
Carlton Hylton has an obvious respect for the elders. With all the covers on this album, how can he not? We here at Night Errands maintain this reverence as well. It's important to listen and learn, for the elders can show us what we are missing, if sometimes via circuitous means. Let's explore a case study.

December 16, 2017. 65 Fenimore Street, Brooklyn, New York. Elder Leo purchases cheap dancehall record out of the hip-hop section. Makes a big fuss. The young author ignores, citing ridiculous cover fonts and non-rare status, content with his selections.

2 hours pass. 985 Main Street, Fishkill, New York. Blazing hot Thai food is consumed. The evening reaches elevated status.

1 hour passes. 267 Main Street, Beacon, New York. Joe McPhee performs a brief, intimate, and beautiful set. The evening gains an Arthurian air.

1 hour passes. 985 Main Street, Fishkill, New York. Leo plays Ghost's <em>Come Back Again</em> on phone in the parking lot. I lose my mind. The evening becomes crystallized.
{{image https://nighterrands.s3.amazonaws.com/thoughts/th07/IMG_20181208_202412.jpg "Responsibly enjoyed"}}
There's your provenance. Sometimes (from the immortal, indefatigable perspective of youth, perhaps often) the elders are just spinning plates and heading nowhere. But every now and then one of those plates holds nourishment, water from the rock, edification. This young author was learned that day.

PS: Yes, Golden Buddha and Fishkill Beer and Soda share an address. Yes, their parking lot is a lovely location for debauchery.
`
    },
    {
        "id": "TH08",
        "title": "Mike's Choice Links",
        "subtitle": "brother ibex, jazz",
        "date": "January 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th08/th08.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th08/th08.jpg",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/th08/th08.jpg ""}}
The human brain is an anticipation machine. Say what you will about people, or jazz musicians, but most are just trying to figure out what comes next.

Now, some folks spend an inordinate amount of time thinking about the future, some of them spend that same time ruminating about the past, and still others, most of whose brains are broken either by God or by choice, remain trapped in the present moment forever. These are the crags in which NightPerson tarries.

Toe, heel, step—
Toe, heel, step—

NightPerson navigates the creaks and cracks of the floor joists akin to Brother Ibex describing the lines on a cliff face. NightPerson, bathed in digital-tinged darkness, seeks the gabagool after midnight, such as Brother Ibex seeks wayward paths, grasses, waters showered in Spanish Sunlight. Brother Ibex, like NightPerson, is held prisoner in the jagged embrace of the present. Needs, wants, desires, all distilled into one beautiful, silent, terrifying frame after the next. Then, repeat. Then, repeat.

Of the moment is of the night. There is clarity of mind at night, as mind is bound to moment. There is a serene absence of mind at night. There is only the here, the now, the quiet hum of the theta from the Bose, the wind biting at the granite under hoof, that choice grass, God’s ‘gool, at night.

Is Cecil Taylor like Brother Ibex, seeking cured meats on ambled peaks? A mad conjuror seeking alchemical cures for death? Both are of the Night, though the latter is beyond reasoning for NightPerson. They recoil at Nefertiti; Brother Ibex flees deftly across basalt cracks known only to he and God.

Cecil threatens to pull us from the present moment, screaming down the unforgiving face of the mountain, the self-aware abyss, and into the warm light of The Beautiful One. 

NightPerson cannot risk it. They fade into the shadows amount scattered furniture, kitchen utensils, refrigerator prize warming in clenched fist. Thirty seconds of Mr. Taylor was enough of a threat.

Gabagool under tongue. Rock, ice underfoot. Errands to be run.
{{embed "<iframe width="560" height="315" src="https://www.youtube.com/embed/4Nz4DSACYPc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>"}}
`
    },
    {
        "id": "TH09",
        "title": "Mike's Choice Links",
        "subtitle": "Waggin'",
        "date": "March 2022",
        "coverImage": {
            "full": "https://nighterrands.s3.amazonaws.com/thoughts/th09/th09.png",
            "small": "https://nighterrands.s3.amazonaws.com/thoughts/th09/th09.png",
        },
        "content": 
`
{{image https://nighterrands.s3.amazonaws.com/thoughts/th09/th09.png ""}}
I've always said smugness is one of my favorite qualities of birds. Sitting on the power lines, waiting for the morning feed, just passing by, the bird is always letting you know that they're up here and you're down there. Hiroshige does an exceptional job capturing this spirit (ISBN 0-8076-1199-9 - why does that duck choose to stand so close to the edge? because they can). 

Look at the way our good friend Kappa struts on in here, heads straight to their mark, then just starts wagging away. So damn smug. The wagging component of the wagtail is really quite special. Really humanizes the little bird. It gets so happy it just has to shake it.

Bird namers really know how to dig down to the essence of a thing. They never miss. Descriptive, brief, accurate, only sometimes narcissistic. We obviously have our Japanese Wagtail here. Alternatively, consider the cinnamon-rumped foliage-gleaner (Philydor pyrrhodes). I bet you can tell where it finds food and what color it's ass is. Great stuff.

The closing sentiment of this particular video has resulted in perhaps my favorite out of context image ever. Get ready to see that one a lot from me.

May peace prevail in the world.
{{embed "<iframe width="560" height="315" src="https://www.youtube.com/embed/yn5u0adcR20" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>"}}
`
    }
];

export function getThoughts() {
    return thoughts;
}

export function getThought(id) {
    return thoughts.find(
        t => t.id === id
    );
}

const bios = [
    {
        "id": "leo",
        "bio": "Chowda house invader.\nThe Plate Spinner.",
        "image": {
            "full": "https://nighterrands.s3.amazonaws.com/images/bios/leo.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/bios/leo-small.jpg"
        }
    },
    {
        "id": "joe",
        "bio": "Hey Joseph, I assume you're probably at work. And now that I'm looking at the time. But anyway, I was just calling to check in. Sorry I had it like a crazy day yesterday. I wasn't done until 8:00 and it was so f****** spent at the end of it, but I didn't even bother to do anything other than lay on my couch will cinnamon on Mars. So give me a call at some point today and we should start figuring out what exactly you were going to do you I don't care where the hell we stay doesn't matter. Just let me know what you found that I can jump on whatever it is the front else., or whatever figure it out, or I don't know if there's a better way. You're you're much better the internet evening than me. So just Pointer figure out what we want to be able to place the right direction and cool. All right. Later.\nOnly smokes Newports.",
        "image": {
            "full": "https://nighterrands.s3.amazonaws.com/images/bios/joe.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/bios/joe-small.jpg"
        }
    },
    {
        "id": "mike",
        "bio": "Don't over drink even if the beer is great!\nChinese propergandist.",
        "image": {
            "full": "https://nighterrands.s3.amazonaws.com/images/bios/mike.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/bios/mike-small.jpg"
        }
    },
    {
        "id": "tyler",
        "bio": "Loudly orders drinks from the propig at 6pm. \"Look everyone, I'm an adult! Look everyone, I can drink!\"\nTrapped in that weird body.",
        "image": {
            "full": "https://nighterrands.s3.amazonaws.com/images/bios/tyler.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/bios/tyler-small.jpg"
        }
    },
    {
        "id": "julie",
        "bio": "aiming to live a life that will get me reincarnated as a slime mold.\nshe'd love to help you raise a barn but she's so tired.",
        "image": {
            "full": "https://nighterrands.s3.amazonaws.com/images/bios/julie.jpg",
            "small": "https://nighterrands.s3.amazonaws.com/images/bios/julie-small.jpg"
        }
    }
]

export function getBios() {
    return bios;
}

export function getBio(id) {
    return bios.find(
        b => b.id === id
    );
}